export { ExameNecroscopico } from './ExameNecroscopico'
